import {Location} from '../common/map/Location';

export class SmoothPointer {
    private locations: Location[] = [];
    private times: number[] = [];

    public setLocation(loc: Location): void {
        this.locations.push(loc);
        this.times.push(Date.now());
        if (this.locations.length > 2) {
            this.locations.shift();
            this.times.shift();
        }
    }

    public getVelocity(): Location {
        if (this.times.length < 2) {
            return new Location(0, 0);
        }
        const dt = this.times[this.times.length - 1] - this.times[0];
        const dtile = this.locations[this.locations.length - 1].sub(this.locations[0]);
        return dtile.multN(1 / (dt / 1000));
    }
}



// WEBPACK FOOTER //
// ./src/game/SmoothPointer.ts